import React, { useEffect, useState } from "react";
import { useForm } from "../../../Hooks/UseForm";
import ButtonGeneric from "../../../components/Buttons/ButtonGeneric";
import InputGeneric from "../../../components/Inputs/InputGeneric";
import { useLocation, useNavigate } from "react-router-dom";
import Spinner from "../../../components/Loading/loadingSpinner/Spinner";
import Modal from "../../../components/Modals/Modal";
import { UseContextApp } from "../../../Global/Context/appContext";
import BreadCrumbsGeneric from "../../../components/Nav/BreadCrumbsGeneric";
import SelectGeneric from "../../../components/Inputs/SelectGeneric";
import { validateDomiciliacionCredito } from "../../../validations/formValidations";
import DomiciliacionController from "../../../controllers/DomiciliacionController";
import { optionPhone, optionTarjeta, formDomiciliacionCredito } from "../../../propsType/Domiciliacion";
import {
  optionAnoMercantil,
  optionMes
} from "../../../propsType/Payemnts";
import { InformationCircleIcon } from "@heroicons/react/outline";
import visa from "../../../assets/bancos/visa-50.jpg";
import mastercard from "../../../assets/bancos/mastercard-50.jpg";
import dinersClub from "../../../assets/bancos/newLogos/Diners Club.png";

function DomiciliacionCredito() {
  const [check, setCheck] = useState(false);
  const [activeModal, setActiveModal] = useState(false);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [{ user }] = UseContextApp();
  const [emailCliente, setEmailCliente] = useState(user?.datos?.email);
  const [nombreCliente, setNombreCliente] = useState(user?.datos?.nombreApellido);
  const [nroCuenta, setNroCuenta] = useState(localStorage.getItem('nroCuenta'))
  const [ciudadCta, setCiudadCta] = useState(localStorage.getItem('ciudadCta'))
  const location = useLocation();
  const pathName = location.pathname;
  const { domiciliacion } = DomiciliacionController();
  const navigate = useNavigate();
  const [isCheckTerminos, setIsCheckTerminos] = useState(false);
  const handleOnTerminos = () => { setIsCheckTerminos(!isCheckTerminos); };
  const [showNroTDC, setShowNroTDC] = useState(false);
  const [showCVV, setShowCVV] = useState(false);
  const CURRENT_MONTH = new Date().getMonth() + 1;
  const CURRENT_YEARS = new Date().getFullYear();


  function filtro(e) {
    var tecla = e.key;
    if (['.', 'e', 'E', '-', ','].includes(tecla))
      e.preventDefault()
  };

  let monto = parseFloat(localStorage.getItem('deudaTotalVEF'))
  localStorage.setItem('deuda', monto);
  const funtionShowCVV = () => { setShowCVV(!showCVV); };
  const funtionShowNroTDC = () => { setShowNroTDC(!showNroTDC); };

  const errores = (errorType) => {
    setCheck(false);
    setLoading(false);
    setActiveModal(true);

    switch (errorType) {
      case "NombreTitular":
        setMessage("Ingresa el nombre y apellido del titular bancario del instrumento de pago.");
        break;
      case "Correo":
        setMessage("Ingresa el correo electrónico del titular bancario del instrumento de pago.");
        break;
      case "Terminos":
        setMessage("Debe aceptar los Términos y Condiciones.");
        break;

    };
  };


  const {
    form,
    errors,
    setForm,
    setErrors,
    handleChange,
    handleSubmit,
    handleBlur,
  } = useForm(
    formDomiciliacionCredito,
    validateDomiciliacionCredito,
    emailCliente,
    nombreCliente
  );

  const closetModal = () => {
    setActiveModal(false);
    setMessage("");

  };

  const volver = () => { navigate('/cuenta/pagos'); };

  const enviarDomiciliar = async () => {
    //Validar Campos

    let bError = "false";
    if ((nombreCliente === "") && (nombreCliente === undefined) && (form.name === "")) { errores("NombreTitular"); bError = "true"; }
    else if ((emailCliente === "") && (emailCliente === undefined) && (form.email === "")) { errores("Correo"); bError = "true"; }
    else if (isCheckTerminos === false) { errores("Terminos"); bError = "true"; }
    if (bError === "false") {
      const result = handleSubmit();
      if (result === "ok") {
        {
 
          let newObjet = {
            nombre: user?.datos?.nombreApellido,
            tipoCliente: (user?.datos?.tipoCliente === "Hogar" ? "Residencial" : "Corporativo"),
            docIdentidad: user?.datos?.docIdentificacion,
            email: emailCliente,
            tlfContacto: form.selectNumber + form.phone,
            ciudad: user?.datos?.ciudad.split(',')[0],
            cuenta: nroCuenta,
            tipoDomiciliacion: "Crédito Nacional",
            bancoCta: "Crédito Nacional",
            bancoTDC: "Crédito Nacional",
            titularBancario: nombreCliente,
            docIdentidadTitularBancario: user?.datos?.docIdentificacion,
            nroCuentaDomiciliar: "",
            nroTarjeta: form.numberCardCredit,
            fechaVencimiento: form.month + "/" + form.year,
            tipoTarjeta: form.tipoTarjeta,
            cvv: form.code
          };
          setLoading(true);
       
          let res = await domiciliacion(newObjet);

          if (res) {
            switch (res?.status) {
              case "0004":
                localStorage.setItem('ticket', res?.ticketNumber);
                localStorage.setItem('titular', newObjet.nombre);
                localStorage.setItem('cuenta', newObjet.cuenta);
                localStorage.setItem('mop', "Crédito Nacional");
                localStorage.setItem('mopNro', newObjet.nroCuentaDomiciliar);
                localStorage.setItem('titularMop', newObjet.titularBancario);
                localStorage.setItem('deuda', monto)
                navigate("/cuenta/domiciliacion/confirmation");
                break;
              default:
                setCheck(false);
                setLoading(false);
                setActiveModal(true);
                setMessage("Por favor chequea los datos bancarios he intenta más tarde.");
                break;
            }
          }
        }
      }
    }
  };


  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  return (
    <div className=" bg-[#f3f4f6] ">
      <div className="flex max-w-7xl mx-auto  pt-6 justify-center min-h-screen">
        {loading ?
          (
            <>
              <div className="w-full h-screen flex justify-center items-center ">
                <Spinner title={"Espere..."} />
              </div>
            </>
          ) : (
            <>
              <div className="rounded-[10px] flex lg:w-full gap-5 px-4  flex-col">
                <BreadCrumbsGeneric locations={pathName} />
                <div className="bg-white rounded-[10px] w-full px-4 py-5 border-b border-gray-200 sm:px-6">
                  <div className="-ml-4 -mt-4 flex justify-between items-center flex-wrap sm:flex-nowrap">
                    <div className="ml-4 mt-4">
                      <h3 className="text-2xl leading-6 font-medium text-gray-900">
                        Domicilia el Pago de tus Servicios
                      </h3>
                      <p className="mt-1 text-sm text-gray-500">Completa la información y haz clic en domiciliar </p>
                    </div>
                  </div>
                  <div className="bg-white rounded-[10px] w-full px-4 py-5  sm:px-1">
                  
                    <div className="h-full flex flex-col gap-5 justify-between lg:pr-[50px] ">
                      <hr className="pt-[10px] mt-[10px]" />
                      <div className="grid lg:gap-[32px] gap-6 lg:relative lg:top-[10px] ">
                        <div className=" grid gap-3 lg:grid-cols-2 lg:gap-10">
                          <div className="grid">
                            <div className="flex gap-[3px] items-center text-gray-900">
                              <p className=" text-sm font-medium  ">
                                Documento de Identidad
                              </p>
                            </div>

                            <div className="col-span-5">
                              <InputGeneric
                                disable={true}
                                placeholder={user?.datos?.docIdentificacion}
                                onChange={handleChange}
                                name={"nroDoc"}
                                value={form.nroDoc}
                                handleBlur={handleBlur}
                                errorText={errors.nroDoc}
                              />
                            </div>

                          </div>
                          <div className="grid">
                            <div className="flex gap-[3px] items-center text-gray-900">
                              <p className=" text-sm font-medium ">Nombre y Apellido</p>
                              <p>
                                <div
                                  className={` button cursor-pointer !w-[14px]`}
                                  data-tooltip={
                                    "Coloca el nombre y apellido como aparece en la tarjeta"
                                  }
                                >
                                  <InformationCircleIcon className=" button !w-[14px]  cursor-pointer  text-green " />
                                </div>
                              </p>
                            </div>
                            <div className="col-span-5">
                              <InputGeneric
                                onChange={e => setNombreCliente(e.target.value)}
                                name={"nameCredito"}
                                value={nombreCliente}
                                errorText={errors.nameCredito}
                                handleBlur={handleBlur}
                              />
                            </div>

                          </div>
                        </div>
                        <div className="grid gap-3 lg:grid-cols-2 lg:gap-10">
                          <InputGeneric
                            title={"Correo Electrónico"}
                            name={"email"}
                            handleBlur={handleBlur}
                            onChange={e => setEmailCliente(e.target.value)}
                            errorText={errors.email}
                            value={emailCliente}
                          />
                          <div className="grid">
                            <div className="flex gap-[3px] items-center text-gray-900">
                              <p className="text-sm font-medium  ">Teléfono de Contacto</p>
                            </div>
                            <div className="grid !mt-1  grid-cols-7">
                              <div className="col-span-2">
                                <SelectGeneric
                                  onChange={handleChange}
                                  value={form.selectNumber || ""}
                                  name={"selectNumber"}
                                  onBlur={handleBlur}
                                  errors={errors.selectNumber}
                                  selectData={optionPhone}
                                />
                              </div>
                              <div className="col-span-5">
                                <InputGeneric
                                  name={"phone"}
                                  type={"number"}
                                  value={form.phone}
                                  onChange={handleChange}
                                  handleBlur={handleBlur}
                                  errorText={errors.phone}
                                  maxValue={7}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="grid gap-3 lg:grid-cols-2 lg:gap-10">
                          <InputGeneric
                            title={"Cuenta a Domiciliar"}
                            name={"cuentaDomiciliar"}
                            disable={true}
                            handleBlur={handleBlur}
                            onChange={handleChange}
                            errorText={errors.cuentaDomiciliar}
                            value={nroCuenta + " - " + ciudadCta}
                          />
                        </div>
                      </div>
                      <div>
                        <p className="mt-1 text-sm text-gray-600">Ingresa los datos de la tarjeta de crédito que deseas domiciliar.</p>
                        <hr className="pt-[10px] mt-[10px]" />

                        <div className=" grid gap-3 lg:grid-cols-2 lg:gap-10 place-items-end">

                          <div className="w-full space-y-1">
                            <div className=" flex items-center gap-[3px] text-gray-900">
                              <p className="text-sm font-medium">
                                Tipo de Tarjeta
                              </p>
                              <p>
                                <div
                                  className={` button cursor-pointer !w-[14px]`}
                                  data-tooltip={
                                    "Selecciona el tipo de tarjeta que deseas domiciliar"
                                  }
                                >
                                  <InformationCircleIcon className=" button !w-[14px]  cursor-pointer  text-green " />
                                </div>
                              </p>
                            </div>
                            <div>
                              <SelectGeneric
                                selectData={optionTarjeta}
                                name={"tipoTarjeta"}
                                onBlur={handleBlur}
                                value={form.tipoTarjeta}
                                onChange={handleChange}
                                errors={errors.tipoTarjeta}
                              />
                            </div>
                          </div>
                          <div className="w-full space-y-1">
                            <div className=" flex items-center gap-[3px] text-gray-900">
                              <p className="text-sm font-medium">
                                Número de Tarjeta de Crédito:
                              </p>
                              <img className=" w-[50px] " src={visa} alt="" /><img className=" w-[50px] " src={mastercard} alt="" /><img className=" w-[50px] " src={dinersClub} alt="" />
                            </div>
                            <InputGeneric
                              name={"numberCardCredit"}
                              handleBlur={handleBlur}
                              onChange={handleChange}
                              errorText={errors.numberCardCredit}
                              value={form.numberCardCredit}
                              type={showNroTDC ? "text" : "password"}
                              show={showNroTDC}
                              funtionShow={funtionShowNroTDC}
                              onKeyDown={(e) => filtro(e)}
                              maxValue={form.tipoTarjeta == "Diners Club" ? 14 : 16}
                            />
                          </div>
                        </div>
                        <div className=" grid gap-3 lg:grid-cols-2 lg:gap-10 place-items-end">
                          <div className="w-full space-y-1">
                            <div className=" flex items-center gap-[3px] text-gray-900">
                              <p className="text-sm font-medium">
                                Código de Seguridad (CVV)
                              </p>
                              <p>
                                <div
                                  className={` button cursor-pointer !w-[14px]`}
                                  data-tooltip={
                                    "Tres dígitos al reverso de la tarjeta"
                                  }
                                >
                                  <InformationCircleIcon className=" button !w-[14px]  cursor-pointer  text-green " />
                                </div>
                              </p>
                            </div>
                            <InputGeneric
                              name={"code"}
                              handleBlur={handleBlur}
                              onChange={handleBlur}
                              errorText={errors.code}
                              value={form.code}
                              type={showCVV ? "text" : "password"}
                              show={showCVV}
                              funtionShow={funtionShowCVV}
                              onKeyDown={(e) => filtro(e)}
                              maxValue={3}
                            />
                          </div>
                          <div className="w-full flex justify-between flex-col lg:flex-row items-center gap-2 ">
                            <div className="flex w-full flex-col gap-2">
                              <div className="flex gap-2 ">
                                <div className="grid w-full ">
                                  <div className="text-sm font-medium text-gray-900">
                                    Mes de Vencimiento
                                  </div>
                                  <div className="grid !mt-1 ">
                                    <SelectGeneric
                                      onChange={handleChange}
                                      value={form.month}
                                      name={"month"}
                                      onBlur={handleBlur}
                                      errors={errors.month}
                                      selectData={optionMes}
                                    />
                                  </div>
                                </div>
                                <div className="grid w-full ">
                                  <div className="text-sm font-medium text-gray-900">
                                    Año de Vencimiento
                                  </div>
                                  <div className="grid !mt-1 ">
                                    <SelectGeneric
                                      onChange={handleChange}
                                      value={form.year}
                                      name={"year"}
                                      onBlur={handleBlur}
                                      errors={errors.year}
                                      selectData={optionAnoMercantil}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <p className="text-[0.8rem] text-[#798791]">
                        Importante: Por favor verifique que los datos suministrados de su tarjeta sean exactos para que su transacción sea exitosa.
                      </p>
                      <div className="flex gap-3 pt-3  flex-col items-center  ">
                        <div className="flex items-start md:items-center gap-3">
                          <input
                            type={"checkbox"}
                            className="mt-[2px] md:m-0"
                            name={"form.terminos"}
                            checked={isCheckTerminos}
                            onChange={handleOnTerminos}
                            value={form.terminos} />
                          <label>
                            {" "}
                            <p className="text-[0.8rem] text-center text-[#798791]">
                              Acepto los{" "}
                              <a
                                target="_blank"
                                className="hover:text-black"
                                href="https://www.netuno.net.ve/cuenta/T%C3%A9rminos_Condiciones_Domicilio_Nacional.pdf"
                              >
                                {" "}
                                <strong>Términos y Condiciones </strong>{" "}
                              </a>{" "}
                            </p>
                          </label>
                        </div>
                      </div>

                      <div className="w-full flex justify-between gap-[50%]">
                        <div className="w-full">
                          <ButtonGeneric funtion={volver} text={"Volver"} />
                        </div>
                        <div className="w-full">
                          <ButtonGeneric funtion={enviarDomiciliar} text={"Domiciliar"} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
      </div>

      <Modal
        string={check ? "check" : "error"}
        message={message}
        active={activeModal}
        setActive={setActiveModal}
      >
        <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
          <div className="flex  flex-col gap-2 ">
            <button
              type="button"
              onClick={(e) => check ? navigate = '/cuenta/pagos' : closetModal()}
              className={` ${check ? "bg-green-500" : "bg-red-500"
                } inline-flex w-full justify-center rounded-md  px-3 py-2 text-sm font-semibold text-white shadow-sm  sm:ml-3 sm:w-auto`}
            >
              Cerrar
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );

}
export default DomiciliacionCredito;